var CompareTable = function(){

    if($(".compare-table").length < 1)
    {
        return;
    }

    $('.compare-table').tablesort();

    var tableImgs = $(".compare-table img");

    $('.compare-table').on('tablesort:complete', function(event, tablesort) {
        tableImgs.unveil();

        if($("#test .sorted").data("reverse"))
        {
        	$("#test .sorted").toggleClass("ascending descending");
        }
    });

    $('.compare-table').on("scroll", function(){
        tableImgs.each(function(){
            this.src = $(this).data("src");
        });
        $(".compare-table").off("scroll");
    });

    $(".compare-table th").data("sortBy", function(th, td, tablesort) {
        var sortVal = ($(td).data().sortValue != null ? $(td).data().sortValue : $(td).text());
        var a = parseFloat((""+sortVal).replace(/[^0-9,.]/g, "").replace(",","."));

        if(a)
        {
            if($(th).data("reverse"))
            {
                return -a;
            }
            return a;
        }

        return td.text();
    });

    if( !$(".sorted.descending")[0] ) return;

    
    $(".sorted.descending")[0].click();




    /*
    *   Filters
    *
    */
    var toplistItems = $(".compare-table tbody tr").toArray();

    var filters = {1:{},2:{},3:{},4:{}};
    var filtersActive = [];
    $(".filters").find("input").on("change", function() {

        filters[$(this).parents(".filter-group").index()][this.id] = this.checked;
        filtersActive = [];
        Object.keys(filters).forEach(function(filterGroup){
            Object.keys(filterGroup).forEach(function(key){
                if(filters[key]) {
                    filtersActive.push(parseInt(key));
                }
            });
        });

        if(window.gtag) {
            gtag('event', 'Filter', {
              'event_category': 'Toplist',
              'event_label': $(this).next().text().trim(),
              'value': 1
            });
        }

        toplistItems.forEach(function(ti){
            var tags = $(ti).data("tags");

            var filtersOk = [];
            Object.keys(filters).forEach(function(filterGroup){
                var disabled = Object.keys(filters[filterGroup]).every(function(id){
                    return !filters[filterGroup][id];
                });
                if(disabled)
                {
                    filtersOk.push(true);
                }
                else
                {
                    if($(".filter-group").eq(filterGroup-1).data("type"))
                    {
                        var valid = true;
                        Object.keys(filters[filterGroup]).forEach(function(id){
                            if(filters[filterGroup][id]) {
                                if(!~tags.indexOf(+id)) {
                                    valid = false;
                                }
                            }
                        });
                        filtersOk.push(valid);
                    }
                    else
                    {
                        var valid = false;
                        Object.keys(filters[filterGroup]).forEach(function(id){
                            if(filters[filterGroup][id]) {
                                if(~tags.indexOf(+id)) {
                                    valid = true;
                                }
                            }
                        });
                        filtersOk.push(valid);
                    }
                }
            });

            var valid = filtersOk.every(function(a){ return a; });

            if(!valid) {
                $(ti).addClass("hidden");
            } else {
                $(ti).removeClass("hidden");
            }
        });

        /*if($("#test .toplist-block:visible").length == 0)
        {
            $("#test").append("<div class='reset'>Inga resultat matchar din filtrering. <span>Klicka här</span> för att återställa.</div>");
        }*/

        $(".compare-table img").unveil();

        filterCount();
    });

    function filterCount(first) {
        var filterCounts = [];

        Object.keys(filters).forEach(function(filterKey){
            var groupFilters =  JSON.parse(JSON.stringify(filters));
            Object.keys(groupFilters[filterKey]).map(function(key){
                groupFilters[filterKey][key] = false;
            });

            var filterItems = toplistItems.slice();
            filterItems = filterItems.map(function(ti){
                var tags = $(ti).data("tags");

                var filtersOk = [];
                Object.keys(groupFilters).forEach(function(filterGroup){
                    var disabled = Object.keys(groupFilters[filterGroup]).every(function(id){
                        return !groupFilters[filterGroup][id];
                    });
                    if(disabled)
                    {
                        filtersOk.push(true);
                    }
                    else
                    {
                        if($(".filter-group").eq(filterGroup-1).data("type"))
                        {
                            var valid = true;
                            Object.keys(groupFilters[filterGroup]).forEach(function(id){
                                if(groupFilters[filterGroup][id]) {
                                    if(!~tags.indexOf(+id)) {
                                        valid = false;
                                    }
                                }
                            });
                            filtersOk.push(valid);
                        }
                        else
                        {
                            var valid = false;
                            Object.keys(groupFilters[filterGroup]).forEach(function(id){
                                if(groupFilters[filterGroup][id]) {
                                    if(~tags.indexOf(+id)) {
                                        valid = true;
                                    }
                                }
                            });
                            filtersOk.push(valid);
                        }
                    }
                });

                var valid = filtersOk.every(function(a){ return a; });

                if(!valid) {
                    return null;
                } else {
                    return ti;
                }
            });

            filterItems.forEach(function(tp){
                if(!tp) {
                    return ;
                }

                $(tp).data("tags").forEach(function(a){
                    if($("#" + a).parents(".filter-group").index() == filterKey) {
                        filterCounts[a] = filterCounts[a] ? filterCounts[a] + 1 : 1;
                    }
                });
            });
        });

        $(".filter input").each(function(){
            var count = filterCounts[this.id];
            $(this).parent().find(".count").html(count ? count : 0);
            if(first && !count) {
                $(this).parent().hide();
            }
        });

        $(".filter-group").each(function(){
            $cc = $(this).find(".filter").get();
            $cc = $cc.sort(function(l,r){
                return parseInt($(r).find(".count").html()) - parseInt($(l).find(".count").html())
            });
            $(this).append($cc);
        });
    }
    filterCount(true);

    
    $(".filters .filters-title").on("click", function(){
        $(this).parent().parent().addClass("active");
        $("body").addClass("filters-open");
    });

    $(".filters .filter-button").on("click", function(){
        $(this).parent().parent().removeClass("active");
        $("body").removeClass("filters-open");
    });
};

module.exports = CompareTable;
